import { Link } from "react-router-dom";
import { useLenis } from "lenis/react";
import { BRAND, NAV_LINKS } from "../data/content";
import { Reveal } from "./Reveal";

export default function Footer() {
  const lenis = useLenis();
  const goTo = (id) => {
    const el = document.getElementById(id);
    if (el && lenis) lenis.scrollTo(el, { offset: -80, duration: 1.4 });
  };

  return (
    <footer data-testid="footer" className="relative overflow-hidden bg-gk-black border-t border-white/10 pt-16 pb-8">
      {/* Massive background year */}
      <span className="pointer-events-none select-none absolute -bottom-8 left-1/2 -translate-x-1/2 font-cinzel font-bold text-[26vw] leading-none text-white/[0.02] whitespace-nowrap">
        2026
      </span>
      <div className="ambient-emerald" style={{ width: 500, height: 300, bottom: "-20%", left: "10%", opacity: 0.25 }} />

      <div className="relative z-10 mx-auto max-w-7xl px-6 md:px-10">
        <Reveal className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img src={BRAND.logo} alt="GK Brandify" className="w-10 h-10 rounded-lg object-cover ring-1 ring-gk-gold/30" />
              <span className="font-cinzel text-lg tracking-[0.22em] text-gold-metallic">GK BRANDIFY</span>
            </div>
            <p className="font-poppins text-sm text-white/55 mt-4 max-w-sm leading-relaxed">
              A luxury creative agency crafting premium brands, websites and digital experiences for the world's most ambitious companies.
            </p>
            <p className="font-inter text-xs tracking-[0.3em] uppercase text-gk-gold/70 mt-4">
              Founder — {BRAND.founder}
            </p>
          </div>

          {/* Nav */}
          <div className="md:col-span-3">
            <h4 className="font-inter text-xs tracking-[0.3em] uppercase text-white/40 mb-6">Navigate</h4>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-nav-${l.id}`}
                    onClick={() => goTo(l.id)}
                    className="font-poppins text-white/65 hover:text-gk-champagne transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Social + contact */}
          <div className="md:col-span-4">
            <h4 className="font-inter text-xs tracking-[0.3em] uppercase text-white/40 mb-6">Connect</h4>
            <ul className="space-y-3 mb-8">
              {BRAND.socials.map((s) => (
                <li key={s.label}>
                  <a
                    data-testid={`footer-social-${s.label.toLowerCase()}`}
                    href={s.href}
                    target="_blank"
                    rel="noreferrer"
                    className="group inline-flex items-center gap-2 font-poppins text-white/65 hover:text-gk-champagne transition-colors"
                  >
                    <span className="h-px w-6 bg-gk-gold/40 group-hover:w-10 transition-all duration-300" />
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>
            <a href={`mailto:${BRAND.email}`} className="block font-poppins text-white/65 hover:text-gk-champagne transition-colors">{BRAND.email}</a>
            <a href={`tel:+${BRAND.phoneRaw}`} className="block font-poppins text-white/65 hover:text-gk-champagne transition-colors mt-1">{BRAND.phone}</a>
          </div>
        </Reveal>

        <div className="hairline-gold w-full mt-12 mb-6 opacity-60" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-inter text-xs tracking-wide text-white/40">
            © 2026 GK Brandify. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <Link data-testid="footer-privacy" to="/privacy" className="font-inter text-xs text-white/50 hover:text-gk-champagne transition-colors">Privacy Policy</Link>
            <span className="h-3 w-px bg-white/15" />
            <Link data-testid="footer-terms" to="/terms" className="font-inter text-xs text-white/50 hover:text-gk-champagne transition-colors">Terms &amp; Conditions</Link>
          </div>
          <p className="font-cinzel text-sm tracking-[0.25em] text-gk-gold/70">
            Building Brands. Shaping the Future.
          </p>
        </div>
      </div>
    </footer>
  );
}
